import React from 'react';
import { Link } from 'gatsby';
import * as Icons from 'react-icons/fi';
import BlockContainer from './BlockContainer';

function Feature({
  feature,
  imageSize,
  showStepNumber,
  textColor,
  isFirst,
  isLast,
  number,
}) {
  const { icon, image, title, description } = feature;

  const size =
    imageSize === 'small'
      ? 60
      : imageSize === 'medium'
      ? 160
      : imageSize === 'large'
      ? 300
      : 60;

  const stepSize =
    imageSize === 'small'
      ? 40
      : imageSize === 'medium'
      ? 70
      : imageSize === 'large'
      ? 100
      : 40;

  const Icon = icon && !image ? Icons[icon] : null;
  return (
    <div className="relative flex flex-col items-center basis-full xl:basis-1/3 lg:p-4">
      {image ? (
        <div
          style={{
            width: size,
            height: size,
            marginBottom: '1rem',
          }}
        >
          <img
            src={image}
            alt={title}
            style={{
              display: 'block',
              maxWidth: size,
              maxHeight: size,
              marginBottom: 0,
            }}
          />
        </div>
      ) : null}
      {Icon ? (
        <span className="opacity-60">
          <Icon
            className="mb-4 stroke-[.8px]"
            style={{ width: size, height: size }}
          />
        </span>
      ) : null}
      {showStepNumber ? (
        <div
          className="rounded-[50%] flex justify-center items-center mb-4"
          style={{
            width: stepSize,
            height: stepSize,
            fontSize: stepSize / 2,
            backgroundColor: textColor,
            color:
              textColor === 'var(--text-light)'
                ? 'var(--text-dark)'
                : 'var(--text-light)',
          }}
        >
          {!isFirst ? (
            <span
              className="hidden lg:block absolute w-[50%] left-[-19px] h-0 border-b-2 border-dashed"
              style={{
                borderColor: textColor,
                width: `calc(50% - ${stepSize / 2}px + 1rem)`,
              }}
            />
          ) : null}
          {!isLast ? (
            <span
              className="hidden lg:block absolute right-[-19px] h-0 border-b-2 border-dashed"
              style={{
                borderColor: textColor,
                width: `calc(50% - ${stepSize / 2}px + 1rem)`,
              }}
            />
          ) : null}
          {number}
        </div>
      ) : null}
      {title ? (
        <h4 className="text-[1.125rem] leading-[1.4] mb-4">{title}</h4>
      ) : null}
      {description ? <p className="mb-0 opacity-60">{description}</p> : null}
    </div>
  );
}

export default function IconFeatures({
  title,
  description,
  features,
  link,
  bgColor,
  textColor,
  padding,
  imageSize = 'small',
  showStepNumbers = false,
}) {
  return title || description || features?.length > 0 ? (
    <BlockContainer
      title={title}
      description={description}
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
    >
      {features?.length > 0 ? (
        <div
          className={`relative flex flex-col lg:flex-row justify-center gap-8 mx-auto${
            title || description ? ' mt-10' : ''
          }${link?.link_url && link?.link_text ? ' mb-10' : ''}`}
        >
          {features.map((feature, i) => (
            <Feature
              key={i}
              feature={feature}
              imageSize={imageSize}
              showStepNumber={showStepNumbers}
              textColor={textColor}
              isFirst={i === 0}
              isLast={i === features.length - 1}
              number={i + 1}
            />
          ))}
        </div>
      ) : null}
      {link?.link_url && link?.link_text ? (
        <Link to={link.link_url}>{link.link_text} →</Link>
      ) : null}
    </BlockContainer>
  ) : null;
}
